(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vehicle-fitment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('motoquipe-fitment')) {
    customElements.define('motoquipe-fitment', class extends HTMLElement {
      connectedCallback() {
        let tags;
        try { tags = JSON.parse(this.dataset.tags || '[]'); } catch { return; }
        if (!Array.isArray(tags)) return;
        const vehicles = new Map();
        for (const tag of tags) {
          if (typeof tag !== 'string') continue;
          const match = tag.trim().match(/^([^-]+)-(.+)-((?:19|20)\d{2})$/);
          if (!match) continue;
          const make = match[1].trim();
          const model = match[2].trim();
          if (!make || !model) continue;
          const key = `${make.toLowerCase()}|${model.toLowerCase()}`;
          if (!vehicles.has(key)) vehicles.set(key, { name: `${make} ${model.replace(/-/g, ' ')}`, years: new Set() });
          vehicles.get(key).years.add(Number(match[3]));
        }
        this.replaceChildren();
        this.hidden = vehicles.size === 0;
        if (this.hidden) return;
        const list = document.createElement('ul');
        for (const vehicle of [...vehicles.values()].sort((a, b) => a.name.localeCompare(b.name))) {
          const years = [...vehicle.years].sort((a, b) => a - b);
          const ranges = [];
          let start = years[0];
          let end = start;
          for (const year of years.slice(1)) {
            if (year === end + 1) { end = year; continue; }
            ranges.push(start === end ? String(start) : `${start}–${end}`);
            start = end = year;
          }
          ranges.push(start === end ? String(start) : `${start}–${end}`);
          const item = document.createElement('li');
          item.textContent = this.dataset.label.replace('__MQ_VEHICLE__', vehicle.name).replace('__MQ_YEARS__', ranges.join(', '));
          list.append(item);
        }
        this.append(list);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
